<template>
    <div>
        <div class="control-block">
            <div class="polygon-visibility-block">
                <p>ヒートマップを表示する</p>
                <input
                    type="checkbox"
                    id="mesh"
                    name="show"
                    v-model="sharedState.meshShowFlag"
                    @click="switchMeshVisibility()">
                <label for="mesh" data-label-on="ON" data-label-off="OFF"></label>
            </div>
        </div>
        <div class="control-block container">
            <label v-for="ptype of ptypes" :key="ptype.label">
                <input type="radio" name="polygon-type"
                    :value="ptype.id"
                    :checked="ptype.id === selectedLayer"
                    v-model="selectedLayer">
                {{ptype.name}}
            </label>
        </div>
        <div class="control-block container">
          <div v-if="this.orNorHouseHold">
            <label v-for="dtype of dtypes_nohousehold" :key="dtype.label">
                <input type="radio" name="data-type"
                    :value="dtype.id"
                    :checked="dtype.id === selectedDataType"
                    v-model="selectedDataType">
                {{dtype.name}}
            </label>
          </div>
          <div v-else>
            <label v-for="dtype of dtypes" :key="dtype.label">
                <input type="radio" name="data-type"
                    :value="dtype.id"
                    :checked="dtype.id === selectedDataType"
                    v-model="selectedDataType">
                {{dtype.name}}
            </label>
          </div>
        </div>
    </div>
</template>

<script>
// import env from '../../../config/dev.env.var.js';

export default {
    name: 'toggle-state',
    data () {
        return{
            ptypes: [
                {
                    "id": 1,
                    "label": "mesh",
                    "name": "メッシュ"
                },
                {
                    "id": 2,
                    "label": "district",
                    "name": "町丁目"
                },
                // {
                //     "id": 3,
                //     "label": "el",
                //     "name": "小学校区"
                // },
                // {
                //     "id": 4,
                //     "label": "jh",
                //     "name": "中学校区"
                // }
            ],
            dtypes: [
                // {
                //     "id": 1,
                //     "label": "population",
                //     "name": "人口"
                // },
                // {
                //     "id": 2,
                //     "label": "household",
                //     "name": "家庭数"
                // }
            ],
            dtypes_nohousehold: [
                {
                    "id": 1,
                    "label": "population",
                    "name": "人口"
                },
            ],
        }
    },
    computed: {
        sharedState() {
            return this.$store.state
        },
        selectedType() {
            return this.$store.state.heatType
        },
        orNorHouseHold() {
          return this.$store.state.config_from_api.NoHousehold
        },
        selectedLayer: {
          get () {
            return this.sharedState.selectedLayer
          },
          set (value) {
            this.$store.commit('setSelectedLayer', value)
          }
        },
        selectedDataType: {
          get () {
            return this.sharedState.selectedDataType
          },
          set (value) {
            this.$store.commit('setSelectedDataType', value)
          }
        },
    },
    methods: {
        switchMeshVisibility () {
            this.$store.commit('switchMeshVisibility')
        }
    },
}
</script>

<style scoped lang="scss">
.polygon-visibility-block {
  padding: 10px 0;
  text-align: center;
  p {
    background: #9a9a9a;
    color: #fff;
    font-size: 1.2em;
    font-weight: bold;
    text-align: center;
    padding: 0.2em 0.5em;
  }
  label {
    margin: 1em 2em 0;
  }
  input {
    display: none;
  }
  input+label,
  input+label::before,
  input+label::after {
    -webkit-transition: all .2s;
    transition: all .2s;
  }
  input+label {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 28px;
    border-radius: 24px;
    cursor: pointer;
  }
  input+label::before {
    display: block;
    content: attr(data-label-off);
    position: absolute;
    top: 4px;
    right: 10px;
    color: #fff;
    font-family: Arial, sans-serif;
    font-size: 16px;
  }
  input+label::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 24px;
    height: 24px;
    background-color: #fff;
    border-radius: 50%;
  }
  input:checked+label::before {
    content: attr(data-label-on);
    left: 10px;
    right: auto;
    color: #fff;
  }
  input:checked+label::after {
    left: 54px;
    background-color: #f7f7f7;
  }

  #mesh+label {
    background-color: #ddd;
  }
  #mesh+label::before {
    color: #393939;
  }
  #mesh:checked+label {
    background-color: #b13df2;
  }
  #mesh:checked+label::before {
    color: #fff;
  }
}
.control-block {
  padding: 5px;
}
.control-block.is-pd5 {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>

